import { CircularProgress } from "@mui/material"
import { AUDIO_ASSESSMENT_EVENTS } from "../../shared/constants/MIXAPANEL_EVENTS"
import { useAssessmentStore } from "../../shared/store"
import { trackMixpanelEvent } from "../../utils/helpers"
import Shell from "../shell"
import AudioPlayer from "./audio-player"

interface RecordingSuccessfulScreenProps {
    audioSrc: string
    handleUploadClick: () => void
    handleRecordAgainClick: () => void
    uploadStatus: "uploading" | "upload-success" | "upload-failure" | null
}

const RecordingSuccessfulScreen = ({
    audioSrc,
    handleUploadClick,
    handleRecordAgainClick,
    uploadStatus,
}: RecordingSuccessfulScreenProps) => {
    const { assesmentQuestions } = useAssessmentStore((state) => state)
    const isVasFlow = assesmentQuestions?.mandatory
    const trackPlayEvent = () => {
        trackMixpanelEvent(AUDIO_ASSESSMENT_EVENTS.ENGLISH_AUDIO_INTRO_RECORED_PLAYED, {
            pageType: isVasFlow ? "VAS" : "Application Flow Enrichment",
        })
    }
    const trackPauseEvent = () => {
        trackMixpanelEvent(AUDIO_ASSESSMENT_EVENTS.ENGLISH_AUDIO_INTRO_RECORDED_PAUSED, {
            pageType: isVasFlow ? "VAS" : "Application Flow Enrichment",
        })
    }
    return (
        <Shell
            footerElement={
                <div className="mt-auto w-full">
                    {uploadStatus === "upload-failure" ? (
                        <p className="text-sm text-[#CB2F4B] text-center mb-2">
                            Upload failed. Please try again
                        </p>
                    ) : (
                        <p className="text-center text-sm text-onSurface-secondary mb-2">
                            Recording will be saved in profile
                        </p>
                    )}
                    <div className="w-full px-4">
                        <button
                            onClick={handleUploadClick}
                            className={`w-[100%] p-4 rounded-lg flex justify-center items-center ${
                                uploadStatus === "uploading"
                                    ? "#fff border border-solid border-green"
                                    : "bg-green"
                            } mt-auto mb-6`}
                        >
                            {uploadStatus === "uploading" ? (
                                <div className="flex items-center justify-center">
                                    <CircularProgress
                                        size={19}
                                        style={{ color: "#2BB792" }}
                                    />
                                    <p className="ml-2 font-semibold text-base text-green">
                                        Uploading
                                    </p>
                                </div>
                            ) : (
                                <p className="ml-2 font-semibold text-base text-white">
                                    Upload
                                </p>
                            )}
                        </button>
                    </div>
                </div>
            }
        >
            <div className="w-[100%] h-[100%] flex flex-col">
                <div>
                    <div className="w-[100%]">
                        <p className="text-xs mb-2">My Audio Recording</p>
                        {/* Audio Player */}
                        <AudioPlayer
                            audioSrc={audioSrc}
                            borderRadiusTop={true}
                            trackPauseEvent={trackPauseEvent}
                            trackPlayEvent={trackPlayEvent}
                        />
                    </div>
                    {/* Record Again Container */}
                    <div className="w-[100%] flex items-center justify-between p-4 bg-[#F4F2F6] rounded-b-lg">
                        <p className="text-xs text-onSurface-primary max-w-[60%]">
                            Audio will be evaluated for spoken English skill test
                        </p>
                        <button
                            className="text-sm text-[#2BB792] border-solid border border-[#2BB792] py-1 px-2 rounded-md font-semibold"
                            onClick={handleRecordAgainClick}
                        >
                            Record Again
                        </button>
                    </div>
                </div>
            </div>
        </Shell>
    )
}
export default RecordingSuccessfulScreen
